import script from "./ingredients-with-dv-section.vue?vue&type=script&setup=true&lang=js"
export * from "./ingredients-with-dv-section.vue?vue&type=script&setup=true&lang=js"

import "./ingredients-with-dv-section.vue?vue&type=style&index=0&id=78482ac6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78482ac6"]])

export default __exports__